<p-dialog
    [header]="operateur?.raisonSociale"
    [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '70rem', height: '40rem' }"
    [contentStyle]="{ overflow: 'auto' }">
    <div class="fiche-operateur">
        <p-fieldset>
            <dl class="def-list">
                <dt>{{ 'page.operateurs.informations.entreprise.structureJuridique' | translate }}</dt>
                <dd [class.no-info]="!operateur?.structureJuridique">{{ operateur?.structureJuridique || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.raisonSociale' | translate }}</dt>
                <dd [class.no-info]="!operateur?.raisonSociale">{{ operateur?.raisonSociale || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.siret' | translate }}</dt>
                <dd [class.no-info]="!operateur?.siret">{{ operateur?.siret || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.tvaIntracommunautaire' | translate }}</dt>
                <dd [class.no-info]="!operateur?.tvaIntracommunautaire">{{ operateur?.tvaIntracommunautaire || withoutInformation }}</dd>
                @for (info of infosDomaine; track info.code) {
                    <dt>{{ info.libelle }}</dt>
                    <dd>{{ info.valeur }}</dd>
                }
            </dl>
        </p-fieldset>
        <p-fieldset>
            <dl class="def-list">
                <dt>{{ 'page.operateurs.informations.entreprise.nom' | translate }}</dt>
                <dd [class.no-info]="!operateur?.nom">{{ operateur?.nom || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.prenom' | translate }}</dt>
                <dd [class.no-info]="!operateur?.prenom">{{ operateur?.prenom || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.adresse' | translate }}</dt>
                <dd [class.no-info]="!operateur?.adresse">{{ operateur?.adresse || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.codePostal' | translate }}</dt>
                <dd [class.no-info]="!operateur?.codePostal">{{ operateur?.codePostal || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.ville' | translate }}</dt>
                <dd [class.no-info]="!operateur?.ville">{{ operateur?.ville || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.cedex' | translate }}</dt>
                <dd [class.no-info]="!operateur?.cedex">{{ operateur?.cedex || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.pays' | translate }}</dt>
                <dd [class.no-info]="!operateur?.pays">{{ operateur?.pays || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.email' | translate }}</dt>
                <dd [class.no-info]="!operateur?.email">{{ operateur?.email || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.telephoneFixe' | translate }}</dt>
                <dd [class.no-info]="!operateur?.telephoneFixe">{{ (operateur?.telephoneFixe | phoneFormat) || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.telephoneMobile' | translate }}</dt>
                <dd [class.no-info]="!operateur?.telephoneMobile">{{ (operateur?.telephoneMobile | phoneFormat) || withoutInformation }}</dd>
                <dt>{{ 'page.operateurs.informations.entreprise.fax' | translate }}</dt>
                <dd [class.no-info]="!operateur?.fax">{{ (operateur?.fax | phoneFormat) || withoutInformation }}</dd>
            </dl>
        </p-fieldset>
    </div>
    <p-table
        #dt
        [value]="cahiersFiltered"
        [columns]="activitesFiltered"
        aria-label="Liste des habilitations">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th scope="col">
                    {{ 'page.common.habilitations.demarches' | translate }}
                </th>
                @for(col of columns; track col.id) {
                    <th scope="col">{{ col.libelle }}</th>
                }
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cahier let-columns="columns">
            <tr>
                <td>{{ cahier.libelle }}</td>
                @for (col of columns; track col.id) {
                    <td>
                        <ng-container *ngTemplateOutlet="habilitationTemplate; context: {
                            cahier: cahier,
                            activite: col,
                            habilitation: getHabilitation(cahier, col)
                        }">
                        </ng-container>
                    </td>
                }
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns ? (columns.length + 1) : 0">
                    <span>{{ 'page.operateurs.habilitations.vide' | translate }}</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<ng-template #habilitationTemplate let-habilitation="habilitation" let-cahier="cahier" let-activite="activite">
    @if(habilitation) {
        <app-statut-badge [statut]="habilitation.statut" class="pointer"></app-statut-badge>
    }
</ng-template>
